import type { VariantProps } from 'class-variance-authority';
import type { PropsWithChildren } from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@/utils/cn';

const goldBadgeVariant = cva(
  'right-1.5 overflow-hidden rounded-full bg-c900 gm-status-current-border font-semibold uppercase text-main-pending gm-status-current-shadow',
  {
    variants: {
      variant: {
        mobile: 'px-1.5 py-1 text-[0.625rem] leading-2.5',
        desktop: 'flex h-7 items-center justify-center px-2 text-xs leading-4.5',
      },
    },
    defaultVariants: {
      variant: 'mobile',
    },
  },
);

interface GmGoldBadgeProps extends PropsWithChildren, VariantProps<typeof goldBadgeVariant> {
  className?: string;
}

export const GmGoldBadge = ({ className, children, variant }: GmGoldBadgeProps) => {
  return (
    <div className={cn(goldBadgeVariant({ variant }), className)}>
      {children}
    </div>
  );
};
